import { decodeJwtPayload } from './keycloakTokenStorage';

/** Hub portal user type from the Keycloak `user_type` JWT claim. */
export type HubUserType = 'staff' | 'client';

type JwtUserTypePayload = {
	user_type?: string;
};

/**
 * Reads the hub user type from an access token.
 * Missing or unknown values are treated as `client` (Keycloak self-heal default).
 */
export function getUserTypeFromToken(accessToken: string | undefined): HubUserType {
	if (!accessToken) {
		return 'client';
	}

	const payload = decodeJwtPayload(accessToken) as JwtUserTypePayload | undefined;
	const userType = payload?.user_type?.toLowerCase().trim();

	if (userType === 'staff') {
		return 'staff';
	}

	return 'client';
}

/** Returns whether the token represents a staff (employee) hub user. */
export function isStaffUser(accessToken: string | undefined): boolean {
	return getUserTypeFromToken(accessToken) === 'staff';
}

/** Returns whether the token represents a client (customer) hub user. */
export function isClientUser(accessToken: string | undefined): boolean {
	return !isStaffUser(accessToken);
}
